import EDataTable from './EDataTable'

export default EDataTable
